// TODO: eliminate all of this in favor of gameday account

import { fromJS, Map, Set } from 'immutable';
import {
  requestCurrentCartCrd,
  requestForecastDepartments,
  saveCurrentAllotments,
  saveFutureAllotments,
  setUseCurrentContract
} from './actions';

export const defaultState = Map({
  currentCartCrd: null,
  forecastShopDepartments: Set([]),
  useCurrentContract: false
});

export default function account(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case requestCurrentCartCrd.event.success:
      return newState.set('currentCartCrd', action.payload);
    case requestCurrentCartCrd.event.error:
      return newState.set('currentCartCrd', '');
    case requestForecastDepartments.event.success:
      return newState.set('forecastShopDepartments', Set(action.payload));
    case setUseCurrentContract.type:
      return newState.set('useCurrentContract', action.payload);
    case saveCurrentAllotments.event.success:
      return newState;
    case saveFutureAllotments.event.success:
      return newState;
    default:
      return newState;
  }
}

export const currentCartCrd = state => state.account.get('currentCartCrd');

export const isFetching = state => state.account.get('isFetching');
export const forecastShopDepartments = state => state.account.get('forecastShopDepartments');
export const useCurrentContract = state => state.account.get('useCurrentContract');
